import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { SectionBReportLayerList } from '../components/Report/SectionBReportLayerList'

export const SectionBReportPageList = () => {
  return (
    <MasterLayout>
      <SectionBReportLayerList/>
    </MasterLayout>
  )
}
